import { INTERPOLATION_REGEX as o } from "./constants.js";
function s(e) {
  const r = /^\/[^/]+\//;
  return e.replace(r, "");
}
function i(e) {
  const r = /^\//;
  return e.replace(r, "");
}
function a(e) {
  return e.replace(/^\/|\/$/g, "");
}
function u(e, r = !1) {
  const n = e.trim();
  return r ? n.split(/(\s|-|_)/).map((t) => /\s|-|_/.test(t) ? t : t.charAt(0).toUpperCase() + t.slice(1)).join("") : n.charAt(0).toUpperCase() + n.slice(1);
}
function l(e) {
  return e.replace(/[A-Z]/g, (r) => "_" + r.toLowerCase());
}
function p(e) {
  return e.replace(/-/g, "_");
}
function f(e) {
  return (e / 1048576).toFixed(2);
}
const g = (e, r) => e.replace(o, (n, t) => t in r ? String(r[t]) : n), m = (e) => e ? e.toString().toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "") : "";
export {
  f as bytesToMb,
  u as capitalize,
  l as convertAndAddUnderscore,
  g as interpolate,
  a as normalizePath,
  s as removeFirstPart,
  i as removeSlashIfExists,
  p as replaceHyphensWithUnderscores,
  m as slugify
};
